import { supabase } from '../lib/supabase.js'

/**
 * Basic test to check if the image generation Edge Function is working
 */
export const testImageServiceConnection = async () => {
  console.log('🧪 Testing image service connection...')
  
  try {
    // Test with minimal data to check if Edge Function is deployed
    const { data, error } = await supabase.functions.invoke('generate-image', {
      body: {
        prompt: 'test image',
        type: 'custom',
        userId: 'test-user-123'
      }
    })

    if (error) {
      console.error('❌ Edge Function invocation error:', error)
      return { success: false, error: error.message }
    }

    console.log('📡 Edge Function response:', data)

    if (data.fallback) {
      console.warn('⚠️ Edge Function returned fallback - likely API key or deployment issue')
      console.warn('Error details:', data.details)
      return { 
        success: false, 
        error: 'API key missing or Edge Function not properly deployed',
        details: data
      }
    }

    if (data.success) {
      console.log('✅ Image service is working correctly!')
      return { success: true, data }
    }

    console.warn('⚠️ Unexpected response from Edge Function:', data)
    return { success: false, error: 'Unexpected response', details: data }

  } catch (error) {
    console.error('💥 Network error:', error)
    return { 
      success: false, 
      error: 'Network error - Edge Function might not be deployed',
      details: error.message
    }
  }
}

// Make available in browser console
if (typeof window !== 'undefined') {
  window.testImageConnection = testImageServiceConnection
  console.log('🧪 Image connection test available: window.testImageConnection()')
}
